import airportTags from "@/constants/airportTags";

import { FilterData, FilterSourceData, FilterSourceItem } from "../typing";
import { getBanksByProgram } from "../utils";

const programsFilterFn = (data: FilterSourceItem, value: FilterData["programs"]): boolean => {
  if (value.length === 0) {
    return true;
  }
  return value.includes(data.program);
};

const banksFilterFn = (data: FilterSourceItem, value: FilterData["banks"]): boolean => {
  if (value.length === 0) {
    return true;
  }
  const banks = getBanksByProgram(data.program);
  return banks.some((v) => value.includes(v));
};

const departureFilterFn = (data: FilterSourceItem, value: FilterData["departure"]): boolean => {
  if (value.length === 0) {
    return true;
  }
  return value.includes(data.route.split("-")[0]);
};

const arrivalFilterFn = (data: FilterSourceItem, value: FilterData["arrival"]): boolean => {
  if (value.length === 0) {
    return true;
  }
  return value.includes(data.route.split("-")[1]);
};

const categoryFilterFn = (data: FilterSourceItem, value: FilterData["category"]): boolean => {
  if (value.length === 0) {
    return true;
  }
  return Array.from(
    new Set(
      airportTags
        .filter((item) => value.includes(item.name))
        .map((item) => item.airports)
        .flat()
    )
  ).some((v) => data.route.split("-")[1] === v);
};

/**
 * 根据过滤条件筛选数据源
 * @param list
 * @param filter
 * @returns
 */
export const useFilterList = (list: FilterSourceData, filter: FilterData): FilterSourceData => {
  return list.filter((item) => {
    return [
      programsFilterFn(item, filter["programs"]),
      banksFilterFn(item, filter["banks"]),
      departureFilterFn(item, filter["departure"]),
      arrivalFilterFn(item, filter["arrival"]),
      categoryFilterFn(item, filter["category"]),
    ].every(Boolean);
  });
};
